import { FC } from 'react';
import { Select as UIKitSelect } from '@urbaninfrastructure/react-ui-kit';

const Select: FC<any> = props => {
  return <UIKitSelect alternative {...props} />;
};

export default Select;
